import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home relative flex flex-col pt-3 overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_main_header = _resolveComponent("main-header")!
  const _component_hero = _resolveComponent("hero")!
  const _component_shorten_form = _resolveComponent("shorten-form")!
  const _component_stats = _resolveComponent("stats")!
  const _component_scroll_to_top = _resolveComponent("scroll-to-top")!
  const _component_cta = _resolveComponent("cta")!
  const _component_main_footer = _resolveComponent("main-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_main_header),
    _createVNode(_component_hero),
    _createVNode(_component_shorten_form, { class: "flex w-10/12 sticky self-center inset-y-6/25 md:inset-y-11/40 xl:inset-y-3/10" }),
    _createVNode(_component_stats),
    _createVNode(_component_scroll_to_top, { class: "fixed flex w-full top-9/10 inset-x-17/20 mm:inset-x-9/10 md:inset-x-19/20" }),
    _createVNode(_component_cta),
    _createVNode(_component_main_footer)
  ]))
}